export { EmployeeDetails } from './EmployeeDetails';
